// Apollo GraphQL mock removed — OTP verification now uses REST/React Query.
// Retained for backward compat; passed to render({ mocks: [...] }) which is a no-op.

export const verifyOtpMock = {
  result: { data: { verifyOtp: true } }
}
